import { Box, Button, Card, Container, Group, Stack, Text, Title, useComputedColorScheme, useMantineTheme } from '@mantine/core'
import { Mail, MapPin, MessageSquare, Phone } from 'lucide-react'
import { Link } from 'react-router-dom'
import { PublicLandingHeader } from '../../components/layout/PublicLandingHeader'

export function Contact() {
  const theme = useMantineTheme()
  const isDark = useComputedColorScheme('dark') === 'dark'

  const colors = {
    page: isDark ? theme.colors.dark[8] : 'var(--sat-bg)',
    surface: isDark ? theme.colors.dark[7] : 'var(--mantine-color-white)',
    mutedSurface: isDark ? theme.colors.dark[6] : 'var(--sat-surface-alt)',
    border: isDark ? theme.colors.dark[4] : 'var(--sat-border-soft)',
    text: isDark ? theme.white : 'var(--sat-text)',
    mutedText: isDark ? theme.colors.gray[3] : 'var(--sat-text-muted)',
  }

  const contactMethods = [
    {
      icon: Mail,
      title: 'Email',
      value: 'support@finderacademy.org',
      description: 'Questions about the platform, subscriptions, or account support.',
    },
  /*   {
      icon: Phone,
      title: 'Phone',
      value: '(555) 240-1280',
      description: 'Available Monday through Friday, 9:00 AM to 5:00 PM Pacific Time.',
    }, */
    {
      icon: MessageSquare,
      title: 'Tutor partnerships',
      value: 'partners@finderacademy.org',
      description: 'Reach out if you are interested in using SAT Tutor with your students.',
    },
   /*  {
      icon: MapPin,
      title: 'Office',
      value: 'San Francisco, California',
      description: 'Remote-first team serving students and tutors across the United States.',
    }, */
  ]

  return (
    <Box style={{ background: colors.page, minHeight: '100vh' }}>
      <PublicLandingHeader />
      <Container size="md" py={{ base: 56, sm: 72 }}>
        <Stack gap={32}>
          <Box
            p={{ base: 'xl', sm: 40 }}
            style={{
              background: colors.surface,
              border: `1px solid ${colors.border}`,
              borderRadius: 24,
            }}
          >
            <Stack gap="lg">
              <Stack gap="sm">
                <Text tt="uppercase" fw={700} fz="sm" c="var(--sat-red)">
                  Contact
                </Text>
                <Title order={1} fz={{ base: 34, sm: 44 }} c={colors.text}>
                  We would love to hear from you.
                </Title>
                <Text fz="lg" lh={1.75} c={colors.mutedText}>
                  Reach out with support questions, tutoring partnership inquiries, or feedback on
                  how SAT Tutor can better serve your students.
                </Text>
              </Stack>

              <Group>
                <Button component="a" href="mailto:support@finderacademy.org" radius="xl" color="red">
                  Email support
                </Button>
                <Button component={Link} to="/about" radius="xl" variant="light" color="red">
                  Learn more about us
                </Button>
              </Group>
            </Stack>
          </Box>

          <Stack gap="lg">
            {contactMethods.map(({ icon: Icon, title, value, description }) => (
              <Card
                key={title}
                padding="xl"
                radius="xl"
                style={{
                  background: colors.surface,
                  border: `1px solid ${colors.border}`,
                }}
              >
                <Group align="flex-start" gap="md" wrap="nowrap">
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 48,
                      height: 48,
                      minWidth: 48,
                      borderRadius: 999,
                      background: colors.mutedSurface,
                      color: 'var(--sat-red)',
                    }}
                  >
                    <Icon size={22} />
                  </Box>

                  <Stack gap={4}>
                    <Text fw={700} fz="lg" c={colors.text}>
                      {title}
                    </Text>
                    <Text fw={600} c={colors.text}>
                      {value}
                    </Text>
                    <Text c={colors.mutedText} lh={1.7}>
                      {description}
                    </Text>
                  </Stack>
                </Group>
              </Card>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  )
}
